import styled from "@emotion/styled";

import { useFormatMessage } from "@skilitics/localization";

import { PlaceholderInput } from "./PlaceholderInput";

export type StatementTitleProperties = {
  value: string;
};

const StatementTitleTextArea = styled(PlaceholderInput)`
  font-size: 30px;
  line-height: 36px;
  font-weight: bold;
  margin-bottom: 16px;
`;

const titleMessages = {
  placeholderTitleLabel: {
    en: "Add your title",
  },
};

type StatementTitleEditorProps = {
  value?: string;
  onChange: (value: string) => void;
};

export const StatementTitleEditor = ({ value = "", onChange }: StatementTitleEditorProps) => {
  const formatMessage = useFormatMessage(titleMessages);

  return (
    <StatementTitleTextArea
      large
      value={value}
      dataTestId={`statement-title-input`}
      placeholder={formatMessage("placeholderTitleLabel")}
      onChange={onChange}
    />
  );
};
